import { Outlet } from 'react-router-dom';

import { useExperimentsReady } from '@zenbusiness/application-commons-experiments';
import PageLoading from '@zenbusiness/zui/PageLoading';

function ExperimentsReadyGate({ children }) {
  const experimentsReady = useExperimentsReady();

  if (!experimentsReady) {
    return <PageLoading />;
  }

  return children || <Outlet />;
}

export default ExperimentsReadyGate;
